<div
  [ngClass]="{
    rating: true,
    'is-positive': typeof rating() === 'number' && rating() === 1,
    'is-negative': typeof rating() !== 'number' || rating() === -1,
    'is-neutral': typeof rating() === 'number' && rating() === 0,
  }"
>
  <claas-icon
    [id]="''"
    [iconId]="
      typeof rating() === 'number' && rating()! > 0
        ? '015503'
        : typeof rating() !== 'number' || rating()! < 0
          ? '015505'
          : typeof rating() === 'number' && rating() === 0
            ? '648620'
            : '015505'
    "
    [namespace]="'pia'"
    [iconStyle]="'bold'"
    [size]="24"
    [alt]=""
    [iconName]="'rating'"
    [removeDefaultColor]="true"
    [class]="'rating-icon'"
  ></claas-icon>
</div>
